// extracted by mini-css-extract-plugin
export var fullHeightState = "_1y-7";
export var headerCell = "_1y-1";
export var loadingStateCell = "_1y-4";
export var rowWrapper = "_1y-3";
export var standaloneTable = "_1y-8";
export var standaloneTableWithBodyFill = "_1y-9";
export var stateCell = "_1y-5";
export var table = "_1y-0";
export var tableBodyFiller = "_1y-6";
export var white = "_1y-2";